export default "__VITE_PUBLIC_ASSET__492350a9__"